import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreBusinessContextSlice } from './get';
import { putCoreBusinessContextSlice } from './put';

import { coreAiContextUploadReducers, coreAiContextUploadWatchers } from './upload';

export const coreAiContextReducers = combineReducers({
	get: getCoreBusinessContextSlice.asyncReducers,
	put: putCoreBusinessContextSlice.asyncReducers,
	upload: coreAiContextUploadReducers
});

export const coreAiContextWatchers = combineAllWatchers([
	getCoreBusinessContextSlice.asyncWatchers,
	putCoreBusinessContextSlice.asyncWatchers,
	coreAiContextUploadWatchers
]);
